/**
 * Created by Andrey Popov on 11.08.2026
 */

const HungryGamesQuestIcon = cc.Node.extend({
    ctor: function (row) {
        this._super();

        this.row = row;
        this.quest = row.data;
        this.id = row.id;

        const styles = cleverapps.styles.QuestIcon;

        const background = new cc.Scale9Sprite(bundles.questsgroupicon.frames.quest_icon_bg);
        background.setAlignment(styles.background);
        this.setContentSize2(background.width * background.scale, background.height * background.scale);
        this.setAnchorPoint(0.5, 0.5);
        this.addChild(background);

        const icon = this.quest.getIcon();
        cleverapps.UI.fitToBox(icon, {
            width: this.width * 0.7,
            height: this.height * 0.7,
            maxScale: styles.icon.maxScale
        });
        icon.setAnchorPoint(icon.anchorX, 0);
        icon.setPosition(this.width / 2, this.height * 0.2);
        this.addChild(icon);

        this.baseScale = 1;

        this.createTimer();

        cleverapps.UI.onClick(this, this.onClicked.bind(this));
        cleverapps.UI.applyHover(this);
    },

    findCustomer: function () {
        if (typeof HungryGamesCustomer === "undefined") {
            return undefined;
        }

        return HungryGamesCustomer.findCustomer();
    },

    createTimer: function () {
        const customer = this.findCustomer();
        if (!customer || !customer.hasLevelTimer() || !customer.levelStartTime) {
            return;
        }

        const styles = cleverapps.styles.QuestIcon.progress;

        const background = this.timer = cleverapps.UI.createScale9Sprite(bundles.questsgroupicon.frames.icon_text_bg_selected);
        background.setContentSize2(styles);
        background.setAnchorPoint(0.5, 0.5);
        background.setAlignment(styles);
        this.addChild(background);

        const countdown = new cleverapps.CountDownView(
            new cleverapps.CountDown(customer.getTimeLeft()),
            {
                font: cleverapps.styles.FONTS.QUEST_PROGRESS_TEXT,
                showHours: false
            }
        );
        countdown.setAlignment(styles.text);
        background.addChild(countdown);
    },

    updateProgressText: function () {
        if (this.timer) {
            this.timer.removeFromParent();
            this.timer = undefined;
        }
    },

    onClicked: function () {
        cleverapps.effects.fire("ui.button.click");

        const customer = this.findCustomer();
        if (!customer) {
            return;
        }

        Map2d.currentMap.customers.selectCustomer(customer.getCustomer());
    }
});
